import { AritoFormV2, AritoIcon, BottomActionBarV2, DialogV2 } from '@/components/custom/erp';
import { initialValues, searchSchema, type SearchFormValues } from '../../schema';
import { useSearchFieldStates } from '../../hooks';
import BasicInfoTab from './BasicInfoTab';

interface SearchDialogProps {
  open: boolean;
  onClose: () => void;
  onSearch: (values: SearchFormValues) => void;
}

const SearchDialog = ({ open, onClose, onSearch }: SearchDialogProps) => {
  const searchFieldStates = useSearchFieldStates();

  const handleSubmit = (formValues: SearchFormValues) => {
    onSearch({
      ...formValues,
      ma_nt: searchFieldStates.ngoaiTe?.uuid || formValues.ma_nt || null,
      tk_co: searchFieldStates.taiKhoan?.uuid || formValues.tk_co || null,
      ma_kh: searchFieldStates.khachHang?.uuid || formValues.ma_kh || null,
      nh_kh1: searchFieldStates.nhomKhachHang1?.uuid || formValues.nh_kh1 || null,
      nh_kh2: searchFieldStates.nhomKhachHang2?.uuid || formValues.nh_kh2 || null,
      nh_kh3: searchFieldStates.nhomKhachHang3?.uuid || formValues.nh_kh3 || null,
      unit_id: formValues.unit_id || null
    });
  };

  return (
    <DialogV2
      open={open}
      onClose={onClose}
      title='Điều kiện lọc'
      maxWidth='md'
      disableBackdropClose
      disableEscapeKeyDown
      titleIcon={<AritoIcon icon={12} />}
    >
      <AritoFormV2<SearchFormValues>
        mode='search'
        hasAritoActionBar={false}
        schema={searchSchema}
        initialData={initialValues}
        onSubmit={handleSubmit}
        onClose={onClose}
        className='w-full min-w-[800px]'
        headerFields={<BasicInfoTab searchFieldStates={searchFieldStates} />}
        bottomBar={<BottomActionBarV2 mode='search' onClose={onClose} submitTitle='Đồng ý' />}
      />
    </DialogV2>
  );
};

export default SearchDialog;
